module.exports = __webpack_public_path__ + "static/img/9.4f051b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/9.jpg
// module id = Loix
// module chunks = 0